import React from 'react'
import { Heading, Section } from 'components'

const TempTerms = () => {
  return (
    <Section className="max-w-4xl mx-auto">
      <Heading>Terms of Agreement</Heading>

      <div className="leading-loose">
        <Heading level="3" className="uppercase my-8">
          This LeadBoxer Membership Agreement (the “Agreement”) is a legal
          contract between you and LeadBoxer, (“LeadBoxer”).
        </Heading>
        <p>
          The Agreement governs your purchase and use of the online website
          measurements service, whether fee-based or free of charge, offered on
          LeadBoxer’s website (each a “Service”). Your use of the Services is
          conditioned on your acceptance of this Agreement. By using any Service
          or by checking the acceptance box at the sign-up page, you accept and
          agree to be bound by all the terms and conditions of this Agreement,
          as well as any additional terms specific to the particular Services
          for which you register.
        </p>
        <p>
          Since this is a binding legal agreement between you and LeadBoxer,
          please print a copy of this Agreement for your records.
        </p>
        <Heading level="3" className="uppercase my-8">
          1. the services
        </Heading>
        <p>
          LeadBoxer will provide you with the Services for which you register on
          LeadBoxer’s website, subject to the terms and conditions of this
          Agreement. With respect to free-trial, the fees referred to in this
          Agreement will be equal to zero Dollars or Euros ($/€ 0.00).
          Descriptions of the Service, are available on LeadBoxer’s website.
        </p>
        <p>
          LeadBoxer reserves the right to modify, enhance, or supplement the
          Services at any time in its sole discretion, provided that those
          modifications do not materially and adversely affect your rights or
          obligations under this Agreement.
        </p>
        <Heading level="3" className="uppercase my-8">
          2. registration process
        </Heading>
        <p>
          To sign up for or receive any Service, you must submit or maintain on
          file with LeadBoxer certain registration data, as requested by
          LeadBoxer’s online registration form for the Service. Such
          registration data shall include, but not be limited to, your name,
          address, email address, website URLs, credit card number, and other
          billing information. (However: LeadBoxer itself does not store, hold,
          process, or access your credit card information. That transaction is
          handled in its entirety by our 3rd party secure processor: Stripe).
          LeadBoxer reserves the right, in its sole discretion, to refuse any
          registration or Service activation request for any reason or no
          reason, and shall not be obligated to provide any Service to you
          unless and until your credit card has been charged for the applicable
          fee. LeadBoxer’s use of your registration information is governed by
          LeadBoxer’s privacy policy.
        </p>
        <Heading level="3" className="uppercase my-8">
          3. your promises and obligations as a condition of receiving any
          services, you promise, represent, and warrant the following.
        </Heading>
        <ol className="list-decimal list-inside space-y-2">
          <li>
            All of the registration information you supply to LeadBoxer is true,
            complete, and accurate, and you will notify LeadBoxer of any changes
            to your registration data during the term of this Agreement and
            submit updated information within twenty (20) days of any such
            changes;
          </li>
          <li>
            None of the URLs you submit to LeadBoxer link to any web page or
            site that contains any:
            <ol className="list-decimal list-inside space-y-2 ml-8 mt-4 mb-4">
              <li>hate propaganda,</li>
              <li>
                material that encourages or promotes illegal activity or
                violence;
              </li>
              <li>
                content that violates or infringes in any way upon the
                statutory, common law, or
              </li>
              <li>
                proprietary rights of others, including but not limited to
                copyrights, trademark rights,
              </li>
              <li>
                patents, or any other third party intellectual property,
                contract, privacy, or publicity rights;
              </li>
              <li>
                material that promotes or utilizes software or services designed
                to deliver unsolicited email;
              </li>
              <li>
                material that violates any local, state, or national law or
                regulation;
              </li>
              <li>
                misrepresentations or material that is threatening, abusive,
                harassing, libelous, or defamatory,
              </li>
              <li>
                obscene, profane, indecent, or otherwise objectionable,
                offensive, or harmful; or
              </li>
              <li>
                other material that LeadBoxer, in its sole discretion, deems
                inappropriate, including any violations of standards posted on
                LeadBoxer’s website or sent to you by email;
              </li>
            </ol>
          </li>
          <li>
            You will safeguard your account user name and password by not
            disclosing your password to any third party, and you will assume
            responsibility for any and all harm or liability attributable to you
            or any other person accessing your account or any Services with your
            user name and password;
          </li>
          <li>
            You will not copy, sell, redistribute, license, sublicense, or
            otherwise transfer your account, or any materials provided to you in
            connection with the Services, to any third party without LeadBoxer’s
            written consent;
          </li>
          <li>
            You will treat any and all consumer information gathered for you or
            transmitted to you via the LeadBoxer website or Services in
            accordance with LeadBoxer’s Privacy Policy;
          </li>
          <li>
            You will comply with all federal laws and regulations governing your
            actions under this Agreement; and
          </li>
          <li>
            You have full power and authority to enter into this Agreement and
            to perform your obligations hereunder.
          </li>
        </ol>
        <p>
          Without limiting its other remedies, LeadBoxer may refuse or cancel
          your account or Services at any time for any violation of the
          foregoing promises. To assure compliance with the criteria in
          Subsection (b) above, LeadBoxer reserves the right to monitor the
          content of the web pages or sites that correspond to the URLs you
          submit to LeadBoxer.
        </p>
        <Heading level="3" className="uppercase my-8">
          4. payment
        </Heading>
        <p>
          You agree to pay LeadBoxer any set-up fees and recurring subscription
          fees listed on LeadBoxer’s website for the service you select.
          Completion and submission of any Service activation form authorizes
          LeadBoxer to charge the credit card specified in your registration for
          all such fees and any related taxes corresponding to the selected
          Service. Such charges will be made on a one-time, monthly, or yearly
          basis. In order to avoid the full fee for any new subscription period,
          you must cancel the Service BEFORE the new period begins. Any failure
          to pay the amounts due under this Agreement will be a material breach
          of your obligations under this Agreement. Without limiting any other
          remedies available to LeadBoxer, YOU AGREE TO FULLY REIMBURSE
          LEADBOXER FOR ANY COSTS AND EXPENSES THAT LEADBOXER MAY INCUR IN
          CONNECTION WITH COLLECTING OR ATTEMPTING TO COLLECT ANY SUCH UNPAID
          AMOUNTS.
        </p>
        <Heading level="3" className="uppercase my-8">
          5. pricing changes and other modifications
        </Heading>
        <p>
          LeadBoxer may change its Service fees, or any other terms of this
          Agreement, at any time by updating the applicable pricing information
          or other terms posted on LeadBoxer’s website. New pricing terms will
          become effective beginning with the first full billing cycle after
          LeadBoxer posts such changes to its website. Changes to terms not
          related to pricing will become effective fifteen (15) days after such
          notification. If you do not agree to any changes posted by LeadBoxer
          in accordance with this Section, you must cancel your account or the
          affected Service as provided herein before the given changes become
          effective; otherwise you will be deemed to have accepted and agreed to
          the changes.
        </p>
        <p>
          Additional modifications to these terms and conditions may be made in
          special circumstances, but only if approved in advance in a signed
          writing on LeadBoxer’s letterhead by an executive vice president or
          higher-level officer of LeadBoxer. Product sales and support
          representatives are not authorized to waive or modify any provisions
          of this Membership Agreement. No failure by LeadBoxer to enforce any
          term of this Agreement shall be construed as a waiver thereof, nor
          shall it affect your obligations or LeadBoxer’s rights and remedies
          hereunder.
        </p>
        <Heading level="3" className="uppercase my-8">
          6. duration and cancellation of services
        </Heading>
        <p>
          Unless stated otherwise on LeadBoxer’s web pages applicable to a given
          Service, each Service will be provided and billed on a monthly or
          yearly subscription basis, measured from the day of payment-activation
          and continuing in like intervals; monthly or yearly. Subscriptions
          will activate regular payments with monthly or annual periods, as
          applicable, until cancelled in accordance with this section. At any
          time after activation of a Service, either you or LeadBoxer may cancel
          that Service (or LeadBoxer may discontinue the Service completely) by
          directly canceling the subscription agreement through the
          payments/billing pages, or the relevant payment processor, in which
          case the Service will terminate at the end of the current monthly or
          yearly billing period. LeadBoxer may cancel the service if you exceed
          a particular number of monthly page views per month. LeadBoxer may
          also increase your subscription fee according to the relevant bracket
          of page views, if your site’s traffic consistently exceeds the bracket
          initially chosen for service.
          <br />
          LeadBoxer also reserves the right to cancel any individual Service
          immediately and without notice in the event that you breach any
          provision of this Agreement or any other terms that apply to that
          Service. NO REFUNDS WILL BE AVAILABLE ON ACCOUNT OF ANY SERVICE
          CANCELLATION BY EITHER PARTY, EXCEPT AS EXPRESSLY PROVIDED IN THE
          SECTION ENTITLED “REFUNDS” BELOW.
        </p>
        <Heading level="3" className="uppercase my-8">
          7. term and termination of agreement
        </Heading>
        <p>
          The terms of this Agreement will begin on the date that LeadBoxer
          accepts your initial registration and will continue in force until
          terminated according to this section. Upon activation of all active
          Services, or any time thereafter, either party may terminate your
          account and this Agreement by written notice to the other party.
          LeadBoxer also reserves the right to terminate your account and this
          Agreement immediately and without notice in the event that you breach
          any provision of this Agreement. No refunds will be available on
          account of any termination of this Agreement, except as expressly
          provided in the Section entitled “Refunds” below. Sections 10 through
          15 of this Agreement shall survive and remain in effect
          notwithstanding any termination of this Agreement. If this agreement
          is terminated by us or by you for any reason, you agree to remove our
          code, logos and trademarks and any other parts of the Service from all
          of your Web sites and other items. Failure to remove our code from
          your website entitles us to act in such a manner as to recover the
          additional costs generated. This manner includes, but is not limited
          to the placement of redirects and/ or pop-ups
        </p>
        <Heading level="3" className="uppercase my-8">
          8. refunds
        </Heading>
        <p>
          If you cancel any Service you acknowledge and agree that NO REFUNDS
          WILL BE ISSUED.
        </p>
        <Heading level="3" className="uppercase my-8">
          9. third party disclosure
        </Heading>
        <p>
          LeadBoxer will not knowingly disclose statistics pertaining to your
          site to a third party, without your explicit permission. In other
          words the data collected and provided by LeadBoxer are strictly
          private and only accessible by our administrators, and the user
          accounts that you create.
        </p>
        <Heading level="3" className="uppercase my-8">
          10. use of tags
        </Heading>
        <p>
          Some of the Services rely on the use of HTML tags or other code in
          your web page or site. Subject to your compliance with all the terms
          of this Agreement, LeadBoxer grants you permission to use the HTML
          tags or other code supplied to you by LeadBoxer (the “Tags”) solely
          for your use in receiving the Services for which you have paid. You
          agree to follow all instructions and restrictions provided to you by
          LeadBoxer with respect to your use of the Tags. You agree that
          LeadBoxer will not be responsible for any malfunctions, errors, data
          inaccuracies, or improper results attributable to your incorrect,
          unauthorized, or unsupported use of any Tags.
        </p>
        <Heading level="3" className="uppercase my-8">
          11. ownership rights
        </Heading>
        <p>
          You agree and understand that the Services and all graphic designs,
          icons, Tags, HTML code, computer programming, and other elements
          incorporated therein are the exclusive property of LeadBoxer. In
          addition, you acknowledge that LeadBoxer owns all right, title, and
          interest in and to LeadBoxer’s trademarks, trade names, service marks,
          inventions, copyrights, trade secrets, patents, technology, software,
          and know-how related to the design, function, or operation of the
          Service. Your rights to the Services are strictly limited to the
          rights expressly granted in this Agreement.
        </p>
        <Heading level="3" className="uppercase my-8">
          12. disclaimer of warranty
        </Heading>
        <p>
          LeadBoxer makes no guarantees of any kind regarding the use or the
          results derived from any Services in terms of dependability, accuracy,
          security, timeliness, availability, reliability, or usefulness. The
          Services and all related materials are provided “AS IS” without
          warranty of any kind. LeadBoxer HEREBY DISCLAIMS ALL WARRANTIES,
          EXPRESS OR IMPLIED, WITH REGARD TO THE SERVICES AND RELATED MATERIALS,
          INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, AND NON-INFRINGEMENT. LEADBOXER DOES NOT WARRANT
          THAT THE OPERATION OF THE SERVICES WILL BE UNINTERRUPTED OR
          ERROR-FREE, OR THAT THE SERVICES WILL BE SUITABLE FOR YOUR NEEDS OR
          YOUR INTENDED APPLICATIONS, OR THAT THE SERVICES WILL BE COMPATIBLE
          WITH OR OPERATE IN THE HARDWARE, SOFTWARE, OR WEBSITE CONFIGURATIONS
          THAT YOU SELECT.
        </p>
        <Heading level="3" className="uppercase my-8">
          13. limitation of liability
        </Heading>
        <p>
          IN NO EVENT WILL LEADBOXER BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
          CONSEQUENTIAL, INCIDENTAL, SPECIAL, OR INDIRECT DAMAGES OF ANY KIND OR
          NATURE, INCLUDING BUT NOT LIMITED TO LOSS OF INCOME, LOSS OR DAMAGE OF
          DATA, AND DAMAGE TO BUSINESS REPUTATION, UNDER ANY THEORY OF LAW OR
          EQUITY, AND WHETHER OR NOT LEADBOXER IS NOTIFIED OF THE POSSIBILITY OF
          SUCH DAMAGES.
        </p>
        <p>
          FURTHERMORE, IN TOTAL, CUMULATIVE LIABILITY UNDER THIS AGREEMENT
          EXCEED THE AMOUNT RECEIVED BY LEADBOXER FROM YOU UNDER THIS AGREEMENT.
          Without limiting the foregoing, LeadBoxer is not responsible for any
          of your data residing on LeadBoxer hardware. You are responsible for
          backing-up your data and information that may reside on the LeadBoxer
          hardware, whether or not such information is produced through the use
          of the Service.
        </p>
        <Heading level="3" className="uppercase my-8">
          14. indemnification
        </Heading>
        <p>
          You agree to indemnify, hold harmless, and (at LeadBoxer’s request)
          defend LeadBoxer and its officers, directors, shareholders, and
          representatives from and against any and all liability, damages,
          losses, costs, or expenses (including but not limited to attorneys’
          fees and expenses) incurred in connection with any claim related to
          (a) your breach of any term, condition, representation, warranty, or
          covenant in this Agreement; or (b) the information you supply to
          LeadBoxer or make available to any third party, including your
          registration data and the content of the web pages corresponding to
          the URLs you submit to LeadBoxer. This obligation shall survive any
          termination of your relationship with LeadBoxer.
        </p>
        <Heading level="3" className="uppercase my-8">
          15. sole and exclusive remedy
        </Heading>
        <p>
          If you are dissatisfied with any portion of any Service, your sole and
          exclusive remedy is to cancel your account or your subscription to the
          given Service according to this Agreement. No refunds are available.
        </p>
        <Heading level="3" className="uppercase my-8">
          16. general provisions
        </Heading>
        <p>
          The laws of the Netherland govern this agreement. You hereby consent
          to the jurisdiction of and venue in courts located in the Netherlands
          in all disputes arising out of or relating to this Agreement or your
          use of the Services. In addition, you hereby consent to the exclusive
          jurisdiction of, and venue in, such courts for any action commenced by
          you against LeadBoxer. The prevailing party in any dispute relating to
          the Services or this Agreement will be entitled to recover its costs,
          expenses and reasonable attorney fees incurred in connection with such
          dispute.
        </p>
        <p>
          This Agreement, along with LeadBoxer’s other terms, conditions, and
          policies referenced herein, constitutes the entire agreement between
          you and LeadBoxer with respect to the Services. To the extent of any
          conflict between this Agreement and LeadBoxer’s Website Terms of Use,
          the Website Terms of Use will govern your general use of LeadBoxer’s
          website, and this Agreement will govern your use of the Services in
          particular. If any part of this Agreement is held to be unenforceable,
          that part will be amended to achieve its intended effect as nearly as
          possible, and the remainder of the Agreement will remain in full
          force.
        </p>
        <p>
          No party shall be liable for failure or delay in performing its
          obligations hereunder if such failure or delay is due to circumstances
          beyond the party’s reasonable control, including without limitation,
          acts of any governmental body or failure of the software or equipment
          of third parties. Except as provided otherwise herein, any notice
          given under this Agreement will be made in writing by email and will
          be effective on the business day after it is sent. You may not assign
          this Agreement, and any attempt to do so is void. You acknowledge that
          your account is part of the LeadBoxer network, and, consequently, you
          will receive periodic announcements and information regarding
          LeadBoxer’s services. You may request to be removed from the network’s
          news mailing list at any time.
        </p>
        <Heading level="3" className="uppercase my-8">
          17. publicity
        </Heading>
        <p>
          LeadBoxer may include your web site’s domain name &amp; logo on its
          customer lists, testimonials and press releases. If at any time you
          would prefer not to be listed, simply let us know, and we will remove
          your name from the list.
        </p>
        <Heading level="3" className="uppercase my-8">
          18. special remarks
        </Heading>
        <p>
          The following types of Web sites are NOT allowed to participate in the
          Service: (a) Web sites which promote illegal activity or racism, or
          which are libelous, defamatory, racist, hate-crime oriented, abusive,
          harassing or threatening, (b) Web sites which contain viruses or other
          contaminating or destructive features, (c) Web sites which violate the
          rights of others, such as Content which infringes any copyright,
          trademark, patent, trade secret or violates any right of privacy or
          publicity, (d) Web sites which provide instructions or discussions
          about performing illegal activities, (e) Web sites that promote or
          utilize software or services designed to deliver unsolicited email, or
          (f) Web sites which otherwise violate any applicable law or that we
          otherwise deem to be inappropriate.
        </p>
        <p>You agree not to change the service’s programming code.</p>
        <p>
          You acknowledge and agree that general information about your Web site
          (name, URL, traffic counts, etc.) may be utilized by the Service.
          Possible uses include (but are not limited to) lists of the busiest
          sites, lists of member sites, general promotional uses, etc.
        </p>
        <p>
          LeadBoxer stores its data in many different formats. ‘Searchable
          data’, is a particular format of data. Searchable data is used for the
          ‘universal search’ feature and is kept for 60 days. The ‘universal
          search’ box is located on the top of ‘visitors online’ report. The
          ‘universal search’ box is experimental and may be removed or not
          function at any time. This will not effect all other reports.
        </p>
        <Heading level="3" className="uppercase my-8">
          19. questions
        </Heading>
        <p>
          If you have any questions about this Agreement or LeadBoxer’s
          Services, please contact LeadBoxer directly.
        </p>
        <p>
          Thank you for choosing LeadBoxer.
          <br />
          We look forward to doing business with you and hope you find our
          services valuable.
        </p>
      </div>
    </Section>
  )
}

export default TempTerms
